import { useContext } from 'react';
import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';
import ItemSelector from 'components/MenuManagement/MenuEdit/MenuMapping/ItemSelector';
import { setSelectedValue } from 'helpers/mappingColumns';

import { CAMEL_TYPES } from 'constants/menuManagement';
import { Group, Stack, Text } from '@mantine/core';
import { Item } from './types';

interface ItemDetailProps {
  item: Item;
}

export default function ItemDetail({ item }: ItemDetailProps) {
  const { checkedItems, setDefaultMods } = useContext(MenuMappingContext);

  const itemType = CAMEL_TYPES.items;

  const { key, uuidExternalId, defaultModifiers, showDefaultModifiers, asInstruction, ignore } =
    item;

  const otherItemChecked = checkedItems?.control && checkedItems.control !== key;

  if (showDefaultModifiers) {
    return (
      <Stack>
        <Group gap="xs2" wrap="nowrap">
          <Text w="var(--dimension-xl)">Item</Text>
          <ItemSelector
            rowKey={key}
            selectedValue={uuidExternalId}
            // @ts-expect-error setSelectedValue not in ts
            setSelectedValue={setSelectedValue}
            selectorItemType={itemType}
            itemType={itemType}
            disabled={otherItemChecked}
          />
        </Group>
        <Group gap="xs2" wrap="nowrap">
          <Text w="var(--dimension-xl)">Mods</Text>
          <ItemSelector
            rowKey={key}
            selectedValue={defaultModifiers}
            setSelectedValue={setDefaultMods}
            selectorItemType={CAMEL_TYPES.modifiers}
            itemType={itemType}
            isDefaultModifier
            disabled={otherItemChecked || !uuidExternalId}
          />
        </Group>
      </Stack>
    );
  }
  return (
    <ItemSelector
      rowKey={key}
      selectedValue={uuidExternalId}
      // @ts-expect-error setSelectedValue not in ts
      setSelectedValue={setSelectedValue}
      selectorItemType={itemType}
      itemType={itemType}
      disabled={!!asInstruction || !!ignore || otherItemChecked}
    />
  );
}
